import { useEffect, RefObject } from 'react';

export const useInitialFocus = (isActive: boolean, elementRef: RefObject<HTMLElement>) => {
  useEffect(() => {
    if (isActive && elementRef.current) {
      requestAnimationFrame(() => {
        elementRef.current?.focus();
      });
    }
  }, [isActive, elementRef]);
};
